export default function() {
  var shop = new Vue({
    el: 'main',
    data: {

    },
    created: function () {
      var topSlider = tns({
        container: '.banners-container',
        items: 1,
        slideBy: 'page',
        mouseDrag: true,
        nav: false,
        autoplay: false,
        controlsText: ["<span></span>","<span></span>"]
      });
    },
    methods: {
      
    }
  });
}


// WEBPACK FOOTER //
// app/javascript/src/javascripts/page/shop.js